import { $t } from '../../composables/i18n'
import { Codebook } from '../Codebook'

export enum LeadSourceChannelId {
  DIRECT_NONE = '(direct) / (none)',
  GOOGLE_CPC = 'google / cpc',
  GOOGLE_ORGANIC = 'google / organic',
  NEWSLETTER_EMAIL = 'newsletter / email',
  BING_CPC = 'bing / cpc',
  SEZNAM_CPC = 'seznam / cpc',
  BING_ORGANIC = 'bing / organic',
  FACEBOOK_CPC = 'facebook / cpc',
  SEZNAM_ORGANIC = 'seznam / organic',
  TIPBOX_TIP = 'tipbox / tip',
  MARKETPLACE = 'marketplace',
  OTHER = 'other',
}

export class LeadChannel extends Codebook<LeadSourceChannelId> {
  static readonly DIRECT_NONE = new LeadChannel(
    LeadSourceChannelId.DIRECT_NONE,
    $t('(direct) / (none)'),
  )
  static readonly GOOGLE_CPC = new LeadChannel(LeadSourceChannelId.GOOGLE_CPC, $t('Google / CPC'))
  static readonly GOOGLE_ORGANIC = new LeadChannel(
    LeadSourceChannelId.GOOGLE_ORGANIC,
    $t('Google / Organic'),
  )
  static readonly NEWSLETTER_EMAIL = new LeadChannel(
    LeadSourceChannelId.NEWSLETTER_EMAIL,
    $t('Newsletter / Email'),
  )
  static readonly BING_CPC = new LeadChannel(LeadSourceChannelId.BING_CPC, $t('Bing / CPC'))
  static readonly SEZNAM_CPC = new LeadChannel(LeadSourceChannelId.SEZNAM_CPC, $t('Seznam / CPC'))
  static readonly BING_ORGANIC = new LeadChannel(
    LeadSourceChannelId.BING_ORGANIC,
    $t('Bing / Organic'),
  )
  static readonly FACEBOOK_CPC = new LeadChannel(
    LeadSourceChannelId.FACEBOOK_CPC,
    $t('Facebook / CPC'),
  )
  static readonly SEZNAM_ORGANIC = new LeadChannel(
    LeadSourceChannelId.SEZNAM_ORGANIC,
    $t('Seznam / Organic'),
  )
  static readonly TIPBOX_TIP = new LeadChannel(LeadSourceChannelId.TIPBOX_TIP, $t('Tipbox / Tip'))
  static readonly OTHER = new LeadChannel(LeadSourceChannelId.OTHER, $t('Other'))
  static readonly MARKETPLACE = new LeadChannel(LeadSourceChannelId.MARKETPLACE, $t('Marketplace'))

  static fromString(value: string | null | undefined): LeadChannel {
    if (!value) return LeadChannel.OTHER

    const found = LeadChannel.all().find((c) => c.id === (value as LeadSourceChannelId))
    return found ?? LeadChannel.OTHER
  }

  private constructor(
    id: LeadSourceChannelId,
    public readonly name: string,
  ) {
    super(id)
  }
}
